import { IThemeSpacers, IThemeStatus, IThemeColor } from "@fortius/prime-ui";
import { get } from "lodash/fp";

export const getThemeValue = (path: string) => get(`theme.${path}`);
export const getThemeSpacers = (path: keyof IThemeSpacers) => get(`theme.$spacers.${path}`);
export const getThemeStatus = (path: keyof IThemeStatus) => get(`theme.$status.${path}`);
export const getThemeColor = (path: keyof IThemeColor) => get(`theme.$color.${path}`);
